import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./PolicyPage.css";

import antiFraudPDF from "../assets/WFH.pdf";
import antiFraudPD from "../assets/AFC.pdf";
import WFO from "../assets/WFO.pdf";
import Moonlighting from "../assets/Moonlighting.pdf";
import Late from "../assets/Late.pdf";
import Appraisal from "../assets/Appraisal.pdf";
import RWLP from "../assets/RWLP.pdf";
import PPRP from "../assets/PPRP.pdf";
import PWHISTLEBLOWER from "../assets/PWHISTLEBLOWER.pdf";

/* ✅ DATE FORMATTER */
const formatDate = (dateStr) => {
  if (!dateStr) return "";

  if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
    const [y, m, d] = dateStr.split("-");
    return `${d}-${m}-${y}`;
  }

  if (/^\d{2}-\d{2}-\d{4}$/.test(dateStr)) {
    return dateStr.replaceAll("-", "/");
  }

  return dateStr;
};

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  const [policies] = useState([
    { id: 1, name: "Anti Fraud Policy", updatedDate: "01-01-2026", pdfUrl: antiFraudPD },
    { id: 2, name: "Work from Home Policy", updatedDate: "01-01-2026", pdfUrl: antiFraudPDF },
    { id: 3, name: "Work from Office-Leave Policy", updatedDate: "01-01-2026", pdfUrl: WFO },
    { id: 4, name: "Moonlighting Policy", updatedDate: "01-01-2026", pdfUrl: Moonlighting },
    { id: 5, name: "Late Mark Policy", updatedDate: "01-01-2026", pdfUrl: Late },
    { id: 6, name: "Performance Appraisal Policy", updatedDate: "01-01-2026", pdfUrl: Appraisal },
    { id: 7, name: "Remote Work Leave Policy", updatedDate: "01-01-2026", pdfUrl: RWLP },
    { id: 8, name: "Prevention, Prohibition, and Redressal Policy", updatedDate: "01-01-2026", pdfUrl: PPRP },
    { id: 9, name: "Whistleblower & Grievance Redressal Policy", updatedDate: "01-01-2026", pdfUrl: PWHISTLEBLOWER },
  ]);

  useEffect(() => {
    const disableContext = (e) => e.preventDefault();
    const disableCopy = (e) => e.preventDefault();

    const disableKeys = (e) => {
      if (
        e.key === "PrintScreen" ||
        (e.ctrlKey && e.key === "s") ||
        (e.ctrlKey && e.key === "p")
      ) {
        e.preventDefault();
        alert("Screenshots and copying are not allowed.");
      }
    };

    document.addEventListener("contextmenu", disableContext);
    document.addEventListener("copy", disableCopy);
    document.addEventListener("keydown", disableKeys);

    return () => {
      document.removeEventListener("contextmenu", disableContext);
      document.removeEventListener("copy", disableCopy);
      document.removeEventListener("keydown", disableKeys);
    };
  }, []);

  const handleViewPolicy = (policy) => {
    if (!policy.pdfUrl) return alert("PDF not available");

    navigate(`/dashboard/organization/policyview/${policy.id}`, {
      state: {
        pdfUrl: `${policy.pdfUrl}#toolbar=0`,
        policyName: policy.name,
      },
    });
  };

  return (
    <div className="policy-container">
      <h2>Policies</h2>

      <div className="policy-table-wrapper">
        <table className="policy-table">
          <thead>
            <tr>
              <th>Sr. No.</th>
              <th>Policy Name</th>
              <th>Updated Date</th>
              <th>View</th>
            </tr>
          </thead>

          <tbody>
            {policies.map((policy, index) => (
              <tr key={policy.id}>
                <td>{index + 1}</td>
                <td>{policy.name}</td>
                <td>{formatDate(policy.updatedDate)}</td>
                <td>
                  <button
                    className="viewButton"
                    onClick={() => handleViewPolicy(policy)}
                  >
                    View
                  </button>
                </td>
              </tr>
            ))}
          </tbody>

        </table>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
